import formatDateInLocalTimezone from '../../utils/dateFormatting'
import Icon from '../../assets/index'

const PublishDateCell = () => {
  return ({ publish_timestamp, status }) => {
    const isScheduled = status === 'scheduled'

    if (!publish_timestamp) {
      return null
    }

    return <div class={isScheduled && 'articles-overview__table-publish-date--scheduled'}>
      {formatDateInLocalTimezone(publish_timestamp)}
      {isScheduled && <Icon
        icon='clock'
        width='16'
        height='16'
      />}
    </div>
  }
}

export default PublishDateCell
